const DEFAULT_IMAGE = 'https://www.asmrchurch.com/static/images/i4.jpg';

function sanitizeDescription(text) {
  return text.replace(/[*_`~[\]()]/g, '').trim();
}

export function toAbsoluteImageUrl(imagePath) {
  if (!imagePath) {
    return DEFAULT_IMAGE;
  }

  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  return `https://www.asmrchurch.com${imagePath}`;
}

export function extractMarkdownMetadata(markdown, defaults = {}) {
  const lines = markdown.split('\n');
  const titleLine = lines.find((line) => line.trim().startsWith('#'));
  const title = titleLine
    ? titleLine.replace(/^#\s*/, '').trim()
    : (defaults.title || '');

  const imageMatch = markdown.match(/!\[.*?\]\((.*?)\)/);
  const rawImage = imageMatch && imageMatch[1] ? imageMatch[1].trim() : '';

  let description = '';
  const titleIndex = lines.findIndex((line) => line.trim().startsWith('#'));
  if (titleIndex >= 0) {
    for (let i = titleIndex + 1; i < lines.length; i += 1) {
      const candidate = lines[i] ? lines[i].trim() : '';
      if (!candidate || candidate.startsWith('#') || candidate.startsWith('!')) {
        continue;
      }
      if (/^\[.*?\]$/.test(candidate) || /^\*[0-9]{4}[-/][0-9]{1,2}[-/][0-9]{1,2}\*/.test(candidate)) {
        continue;
      }
      description = sanitizeDescription(candidate).substring(0, 200);
      break;
    }
  }

  return {
    title: title || defaults.title || '',
    description: description || defaults.description || '',
    rawImage,
    image: toAbsoluteImageUrl(rawImage),
  };
}

export async function fetchStaticMarkdown(staticPath) {
  const response = await fetch(`/static/markdown${staticPath}.md`, { cache: 'no-cache' });
  if (!response.ok) {
    throw new Error(`Markdown file not found: ${staticPath}`);
  }
  return response.text();
}

export { DEFAULT_IMAGE };
